import { render, staticRenderFns } from "./listMessage.vue?vue&type=template&id=62f18275&scoped=true"
import script from "./listMessage.vue?vue&type=script&lang=js"
export * from "./listMessage.vue?vue&type=script&lang=js"
import style0 from "./listMessage.vue?vue&type=style&index=0&id=62f18275&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f18275",
  null
  
)

export default component.exports